import { useState, useEffect, useRef } from 'react';

import { mocks_console } from './TooltipConsole.mocks';
import { showAnimation } from './TooltipConsole.animation';

export const useTooltipConsole = () => {
  const contentText = mocks_console.split('\n');
  const consoleRef = useRef<HTMLDivElement>(null);

  const [isMinimize, setIsMinimize] = useState<boolean>(false);

  const handleAction = (type: 'minimize' | 'restore' | 'close' | 'button') => {
    if (consoleRef.current && consoleRef.current.children.length > 0) {
      const [buttonsConsole, tooltipConsole] = consoleRef.current
        .children as unknown as HTMLDivElement[];

      switch (type) {
        case 'button':
          setIsMinimize(!isMinimize);
          break;
        case 'minimize':
          setIsMinimize(false);
          break;
        case 'close':
          showAnimation(buttonsConsole, false);
          showAnimation(tooltipConsole, false);
          break;
        case 'restore':
          setIsMinimize(false);
          break;
      }
    }
  };

  useEffect(() => {
    if (consoleRef.current && consoleRef.current.children.length > 0) {
      const [buttonsConsole, tooltipConsole] = consoleRef.current
        .children as unknown as HTMLDivElement[];

      showAnimation(buttonsConsole, true);
      showAnimation(tooltipConsole, isMinimize);
    }
  }, [isMinimize]);

  return { consoleRef, contentText, isMinimize, handleAction };
};
